import Axios from 'axios';
export default {
  
  getAllUsers (filter) {     
    let query = `busqueda=${JSON.stringify(filter)}`;
    return Axios.get(`account/getallusers/?${query}`);
  },
  getUserInfo () {     
    
    return Axios.get(`ordenescompra/GetUserInfo/`);
  },
  login (model) {
     
    return Axios.post(`account/login/`, model);
  },
  create (model) {
    
    return Axios.post(`account/register/`, model);
  },
  update (model) {
     
    return Axios.post(`account/update/`, model);
  },
  delete (model) {
     
    return Axios.post(`account/delete/`, model);
  },
  getUserMenu (model) {
     
    return Axios.post(`account/getusermenu/`, model);
           
  }
}
